import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/doprava-a-platba" as const,
	[Locale.en]: "/delivery-and-payment" as const,
} satisfies LocalizedString;

export function getDeliveryAndPaymentPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
